export type RegistrationMode = "mock" | "live";

export const nfcAgents = [
  {
    id: "yx001",
    registrationUrl: "https://yx9935.com?proxy=hjk9iw",
    card: { id: "YX001-C001", token: "p7Kx2mQ9Vd4Nw8Lc3Zt6Ra", shortCode: "7QK9M2XA" },
  },
  {
    id: "yx002",
    registrationUrl: "https://yx9935.com?proxy=25d4vu",
    card: { id: "YX002-C001", token: "H4uY9sB2qF7eK5xM8cW3Pn", shortCode: "4R8V6CNP" },
  },
  {
    id: "yx003",
    registrationUrl: "https://m.yx9935.com/login",
    card: { id: "YX003-C001", token: "t6Rk3Vn8Jp2Zd7Qm5Bx9Hs", shortCode: "9H3T7KWD" },
  },
  {
    id: "yx004",
    registrationUrl: "https://m.yx9935.com/login",
    card: { id: "YX004-C001", token: "C9wF4aL7yT2nK8pR6vX3Me", shortCode: "2M6X8BQA" },
  },
  {
    id: "yx005",
    registrationUrl: "https://m.yx9935.com/login",
    card: { id: "YX005-C001", token: "m2Qz8Dk5Wc9Hf3Ya7N6LtP", shortCode: "5Y9F4LZR" },
  },
] as const;

export const appConfig = {
  projectName: "914go-nfc-system",
  brandName: "914go",
  pageTitle: "914go NFC 活動系統",
  publicSiteUrl: "https://914go-nfc-system.pages.dev",
  campaignId: "launch-2026-08",
  demoMode: true,
  promoUrl: "https://yx9935.com/",
  registrationUrl: "https://m.yx9935.com/login",
  registrationMode: "live" as RegistrationMode,
  lineUrl: "https://lin.ee/7XNsz3Q",
  nfcAgents,
  prizes: ["88", "188", "288", "388", "588", "888"],
} as const;

export type Prize = (typeof appConfig.prizes)[number];
export type AgentId = (typeof nfcAgents)[number]["id"];
export type NfcCardId = (typeof nfcAgents)[number]["card"]["id"];
